import "./MechanicalBullPriceGuide.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import Inventory from "./sections/Inventory";
import PriceFactors from "./sections/PriceFactors";
import BullPrices from "./sections/BullPrices";
import UsedPrices from "./sections/UsedPrices";
import Pricing from "./sections/Pricing";
import BullCost from "./sections/BullCost";
import Included from "./sections/Included";
import Buy from "./sections/Buy";
import Valuation from "./sections/Valuation";
import Costs from "./sections/Costs";
import PricingFaq from "./sections/PricingFaq";
import ComparePrices from "./sections/ComparePrices";
export default function MechanicalBullPriceGuidePage() {
  return <div>
      <Header />
      <Hero />
      <Inventory />
      <PriceFactors />
      <BullPrices />
      <UsedPrices />
      <Pricing />
      <BullCost />
      <Included />
      <Buy />
      <Valuation />
      <Costs />
      <PricingFaq />
      <ComparePrices />
      <Footer />
    </div>;
}